import { IStall } from "../../../api/zone/zone.api";
import { colors } from "../../../constants/colors";
import { STATUS } from "../../store/stall-manage/enum/enum";

/** จุดเดียวที่นิยาม "แผงไหนเลือกเข้าประกาศได้"
 *  admin กำลังร่างประกาศ จึงเลือกได้เฉพาะแผงที่ยังว่าง (BLANK)
 *  ถ้า BA ให้ประกาศซ้ำแผงที่เปิดจองอยู่แล้วได้ ให้เพิ่ม STATUS.OPEN ที่นี่ที่เดียว */
export const SELECTABLE_STATUS: string[] = [STATUS.BLANK];

/** ค่าพิเศษของ filter สถานะ = ไม่กรอง */
export const STALL_STATUS_ALL = "ALL";

export interface IZoneRow {
  zoneId: number;
  zoneName: string;
  zoneNameEn: string;
  /** แผงในโซนนี้ ตัด status DELETED ออกแล้ว */
  stall: IStall[];
  countAll: number;
  countBlank: number;
  countReserve: number;
  countContract: number;
}

export const isStallSelectable = (stall?: IStall | null): boolean =>
  !!stall && stall.stallId != null && SELECTABLE_STATUS.includes(stall.status || "");

/** copy จาก map.tsx:38-50 โดยตั้งใจ — map.tsx เป็นไฟล์ shared ของ admin/customer
 *  ที่ยังมี change ค้างอยู่ จึงไม่ export ออกมาจากที่นั่น
 *  TODO: ย้ายไปรวมกับ stall_status/renderStatus ที่ stall-manage/enum/enum.ts ทีหลัง */
export const checkStatusColor = (status?: string): string => {
  if (status === STATUS.OPEN) return colors.themeThirdColor;
  if (status === STATUS.BLANK) return colors.themeSecondColor;
  if (status === STATUS.RESERVE) return colors.yellow;
  if (status === STATUS.CONTRACT) return colors.sky;
  if (status === STATUS.NON_INFO) return colors.danger;
  return colors.gray;
};

/** แปลง IZone[] ดิบจาก ZoneApi.list เป็นแถวของตารางโซน พร้อมตัวเลขนับ
 *  ตัวเลขนับมาจากแผงทั้งโซนเสมอ ไม่ผูกกับ filter ของ level 2 */
export const toZoneRows = (mapData: any[]): IZoneRow[] => {
  if (!Array.isArray(mapData)) return [];

  return mapData
    .filter((zone: any) => zone?.zoneId != null)
    .map((zone: any) => {
      const stall: IStall[] = (zone?.stall || []).filter(
        (s: any) => s?.status !== STATUS.DELETED
      );

      return {
        zoneId: Number(zone.zoneId),
        zoneName: zone?.zoneName || "",
        zoneNameEn: zone?.zoneNameEn || "",
        stall,
        countAll: stall.length,
        countBlank: stall.filter((s) => s?.status === STATUS.BLANK).length,
        countReserve: stall.filter((s) => s?.status === STATUS.RESERVE).length,
        countContract: stall.filter((s) => s?.status === STATUS.CONTRACT).length,
      };
    });
};

export const filterZoneRows = (rows: IZoneRow[], keyword: string): IZoneRow[] => {
  const key = keyword.trim().toLowerCase();
  if (!key) return rows;
  return rows.filter(
    (row) =>
      (row.zoneName || "").toLowerCase().includes(key) ||
      (row.zoneNameEn || "").toLowerCase().includes(key)
  );
};

export const filterStalls = (
  stalls: IStall[],
  keyword: string,
  status: string
): IStall[] => {
  const key = keyword.trim().toLowerCase();

  return stalls.filter((stall) => {
    if (status !== STALL_STATUS_ALL && stall?.status !== status) return false;
    if (!key) return true;
    return (
      (stall?.stallName || "").toLowerCase().includes(key) ||
      (stall?.stallNumber || "").toLowerCase().includes(key)
    );
  });
};

/** page เป็น 1-based ตาม TableCustom */
export const paginate = <T,>(arr: T[], page: number, pageLimit: number): T[] =>
  arr.slice((page - 1) * pageLimit, page * pageLimit);
